module.exports = __webpack_public_path__ + "img/VA.6b67bc45.svg";